import styled from 'styled-components'
import { useEffect } from 'react'
import { useNavigate } from 'react-router'

import Notification from 'components/Shared/Notification/Index'
import LoadingIndicator from 'components/Shared/LoadingIndicator/Index'
import SignInForm from './SignInForm'

import { useSandboxAuthenticateQuery } from 'api/sessionUser'

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`

const SignInPanel = () => {
  const { data, isFetching } = useSandboxAuthenticateQuery()

  const navigate = useNavigate()

  useEffect(() => {
    if (!isFetching && data.error) {
      navigate('/')
    }
  }, [isFetching]) // eslint-disable-line react-hooks/exhaustive-deps

  const partnersWithRoles = data?.partners

  if (isFetching) {
    return <LoadingIndicator loading={isFetching} />
  }

  return (
    <StyledWrapper>
      <Notification />
      <SignInForm partners={partnersWithRoles} />
    </StyledWrapper>
  )
}

export default SignInPanel
